import React from "react";
import { FaBuilding, FaHouseUser, FaUserTie, FaLandmark } from "react-icons/fa";
import simg from "../../images/services.jpg"
import "../../css/service.css";



const Services = () => {
  return (
    <div className="features-section-sec">
    {/* Hero Section with Overlay */}
    <div className="features-image-container">
      <img src={simg} alt="Smiling woman" className="features-image" />
      <div className="features-overlay">
        <h2>Services We Provide</h2>
     
      </div>
    </div>

    {/* Features Grid */}
    <div className="features-content">
      <div className="features-grid-sec">
        <div className="feature-item">
          <FaBuilding className="feature-icon" />
          <div>
          <h3>Buy Property</h3>
          <p>
          Find verified homes, plots, and commercial spaces across Chennai. Guided by your local Pincode Expert, every step of the way.
          <br /> <br />🔹 For Families | First-Time Buyers | Investors
          </p>
          </div>
        </div>
        <div className="feature-item">
          <FaHouseUser className="feature-icon" />
          <div>
          <h3>Sell Property</h3>
          <p>
          List your property with confidence. We help you find serious buyers, handle site visits, and manage the paperwork professionally.
          <br /> <br />🔹 Fast Closures | Transparent Process
          </p>
          </div>
        </div>
        <div className="feature-item">
        <FaUserTie className="feature-icon" />
          <div>
          <h3>Commercial Services</h3>
          <p>
          Lease, rent or buy office spaces, retail outlets, showrooms, and more — across prime business locations.
          <br /> <br />🔹Local Market Insight | Legal Support
          </p>
          </div>
        </div>
        {/* <div className="feature-item">
          <FaLandmark className="feature-icon" />
          <div>
          <h3>Rent / Lease</h3>
          <p>
          Whether it’s a home or office, get connected with verified tenants or landlords in your area.
          🔹 PG, Residential, Commercial Rentals
          </p>
          </div>
        </div>
        <div className="feature-item">
        <FaUserTie className="feature-icon" />
          <div>
          <h3>PG / Co-Living </h3>
          <p>
          Find or list shared accommodations with ease. Perfect for students, working professionals, and co-living setups.
          🔹 Fully Managed | Verified Leads
          </p>
          </div>
        </div> */}
        <div className="feature-item">
          <FaLandmark className="feature-icon" />
          <div>
          <h3>Consultation &<br/> Documentation</h3>
          <p>
          From legal advice to agreement drafting, we offer full support for a smooth transaction.
          <br /> <br /> 🔹 Document Writing | Loan Assistance | Registration
          </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  );
};

export default Services;
